export const addResultsMain = {
    namespaced: true,

    state: {
        session: null
    },

    getters: {
        session(state) {
            return state.session;
        }
    },

    mutations: {
        sessionSave(state, data) {
            state.session = data;
        },

        emptyStore(state) {
            state.session = null;
        }
    },

    actions: {
        getSessionDetails(context, payload) {
            return context.dispatch(
                'get',
                {
                    url: `${api}session/${payload.id}?fields=id|name|session_id|session|sport|start_date|alternative_results|pieces_count|club_id`,
                    params: {
                        include: [
                            'attendance',
                            'crews.crew_users.user:fields(id|first_name|last_name|full_name|picture)',
                            'participants:fields(user_id|attendance|ill|injured|did_alternative)',
                            'session.structure.pieces.crews.results',
                            'session.structure.pieces.crews:order(finish_time|asc)',
                            'session.structure.pieces.crews.crew_users.user:fields(id|first_name|last_name|full_name|picture)',
                            'sport_crew_results.crews.crew_users:fields(user_id)',
                            'sport_crew_results.crews.crew_users.user:fields(id|first_name|last_name|full_name|picture)',
                            'sport_crew_results.crews.pieces',
                            'sport_user_results.users:fields(id|first_name|last_name|full_name|picture|pieces|overall_results)',
                            'user_actions'
                        ].join(',')
                    }
                },
                { root: true }
            );
        }
    }
};

export default addResultsMain;
